// extracted by mini-css-extract-plugin
module.exports = {"container":"SkipTaskConfirmationModal_container__HCGEI","main":"SkipTaskConfirmationModal_main__AaF0E"};